import { motion, AnimatePresence } from 'framer-motion';
import useNotificationStore from '@/store/notificationStore';

const icons = { success: '✅', error: '❌', info: '💬', warning: '⚠️' };
const colors = {
  success: 'bg-forest border-forest-light',
  error: 'bg-pirate-red border-red-400',
  info: 'bg-ocean border-ocean-light',
  warning: 'bg-gold-dark border-gold',
};

export default function ToastContainer() {
  const { toasts, removeToast } = useNotificationStore();

  return (
    <div className="pointer-events-none fixed left-0 right-0 top-4 z-[100] flex flex-col items-center gap-2 px-4">
      <AnimatePresence>
        {toasts.map((toast) => (
          <motion.div
            key={toast.id}
            initial={{ opacity: 0, y: -20, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -20, scale: 0.9 }}
            className={`pointer-events-auto flex w-full max-w-sm items-center gap-3 rounded-2xl border-2 px-5 py-3 font-body font-semibold text-white shadow-game-card ${colors[toast.type]}`}
            onClick={() => removeToast(toast.id)}
          >
            <span>{icons[toast.type]}</span>
            <span className="flex-1 text-sm">{toast.message}</span>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
}
